/**
 * TanStack Query hooks for `appsflyer-integration-mmp-bridge`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	appsflyerIntegrationMmpBridgeQueryKeys,
	type CreateAppsflyerIntegrationMmpBridgeBody,
	type ListAppsflyerIntegrationMmpBridgeResponse,
	type AppsflyerIntegrationMmpBridgeRow,
} from "./api";

export function useAppsflyerIntegrationMmpBridgeList(): UseQueryResult<ListAppsflyerIntegrationMmpBridgeResponse, Error> {
	return useQuery({
		queryKey: appsflyerIntegrationMmpBridgeQueryKeys.list(),
		queryFn: list,
	});
}

export function useAppsflyerIntegrationMmpBridgeCreate(): UseMutationResult<AppsflyerIntegrationMmpBridgeRow, Error, CreateAppsflyerIntegrationMmpBridgeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: appsflyerIntegrationMmpBridgeQueryKeys.all });
		},
	});
}

export function useAppsflyerIntegrationMmpBridgeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: appsflyerIntegrationMmpBridgeQueryKeys.all });
		},
	});
}
